import { useContext } from 'react'

import { BeneficiaryListAsSheetContext } from '@/components/beneficiary/list/sheet/context'

export const useBeneficiaryListAsSheet = () => {
  const context = useContext(BeneficiaryListAsSheetContext)
  if (!context) {
    throw new Error(
      'useBeneficiaryListAsSheet must be used within a BeneficiaryListAsSheetContext.Provider',
    )
  }
  return context
}
